/**
 * Angular imports.
 */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

/**
 * Guard imports.
 */
import { RouteParamGuard } from '../auth/routeParam.guard';
import { openAccessGuard } from '../auth/open-access.guard';

/**
 * Component imports.
 */
import { MiddleWareComponent } from '../authorised-zone/middle-ware.component';

/**
 * service imports
 */
import { NewLanguageService } from '../dataservices/new-language/new-language.service';

const mls = new NewLanguageService();


const appRoutes: Routes = [
  {
    path: '',
    component: MiddleWareComponent,
    canActivate: [RouteParamGuard],
    children: [
      {
        path: 'web',
        loadChildren: () => import('../web/web.module')
          .then(m => m.WebModule),
      },
      {
        path: 'connection',
        data: {
          moduleName: mls.featureOnOffList.moduleList.CONNECTION
        },
        canLoad: [openAccessGuard],
        loadChildren: () => import('../connection/connection.module')
          .then(m => m.ConnectionModule),
      },
      {
        path: 'clinical',
        loadChildren: () => import('../clinical-resource/clinical-resource.module')
          .then(m => m.ClinicalResourceModule),
      },
      {
        path: 'refer-and-earn',
        loadChildren: () => import('../refer-and-earn/refer-and-earn.module')
          .then(m => m.ReferAndEarnModule),
      },
      {
        path: 'search',
        loadChildren: () => import('../search/search.module')
          .then(m => m.SearchModule),
      },
      {
        path: 'survey',
        data: {
          moduleName: mls.featureOnOffList.moduleList.SURVEY
        },
        canLoad: [openAccessGuard],
        loadChildren: () => import('../survey/survey.module')
          .then(m => m.SurveyModule),
      },
      {
        path: 'cme',
        data: {
          moduleName: mls.featureOnOffList.moduleList.CME
        },
        canLoad: [openAccessGuard],
        loadChildren: () => import('../web-cme/web-cme.module')
          .then(m => m.WebCmeModule),
      },
      {
        path: 'doctalk',
        loadChildren: () => import('../web-doctalk/web-doctalk.module')
          .then(m => m.WebDoctalkModule),
      },
      {
        path: 'webinar',
        loadChildren: () => import('../webinar/webinar.module')
          .then(m => m.WebinarModule),
      },
      {
        path: 'event',
        data: {
          moduleName: mls.featureOnOffList.moduleList.OFFLINE_EVENT
        },
        canLoad: [openAccessGuard],
        loadChildren: () => import('../web-events/web-events.module')
          .then(m => m.WebEventsModule),
      },
      {
        path: 'channel',
        loadChildren: () => import('../web-channel/web-channel.module')
          .then(m => m.WebChannelModule),
      },
      {
        path: 'drugsample',
        data: {
          moduleName: mls.featureOnOffList.moduleList.DRUG_SAMPLE
        },
        canLoad: [openAccessGuard],

        loadChildren: () => import('../drug-sample/drug-sample.module')
          .then(m => m.DrugSampleModule),
      },
      {
        path: 'webcalendar',
        data: {
          moduleName: mls.featureOnOffList.moduleList.CALENDAR
        },
        canLoad: [openAccessGuard],
        loadChildren: () => import('../web-calendar/web-calendar.module')
          .then(m => m.WebCalendarModule),
      },
      {
        path: 'webprofile',
        loadChildren: () => import('../web-profile/web-profile.module')
          .then(m => m.WebProfileModule),
      },
      {
        path: 'pharma',
        data: {
          moduleName: mls.featureOnOffList.moduleList.PHARMA
        },
        canLoad: [openAccessGuard],
        loadChildren: () => import('../e-detailing/e-detailing.module')
          .then(m => m.EDetailingModule),
      },
      {
        path: 'meeting',
        data: {
          moduleName: mls.featureOnOffList.moduleList.MEETING
        },
        canLoad: [openAccessGuard],
        loadChildren: () => import('../meeting/meeting.module')
          .then(m => m.MeetingModule),
      },
      {
        path: 'eventv3',
        data: {
          moduleName: mls.featureOnOffList.moduleList.ONLINE_EVENT
        },
        canLoad: [openAccessGuard],
        loadChildren: () => import('../event/event.module')
          .then(m => m.EventModule),
      },
      {
        path: 'editor-choice',
        data: {
          moduleName: mls.featureOnOffList.moduleList.EDITOR_CHOICE
        },
        canLoad: [openAccessGuard],
        loadChildren: () => import('../editor-choice/editor-choice.module')
          .then(m => m.EditorChoiceModule),
      },
      {
        path: 'game',
        data: {
          moduleName: mls.featureOnOffList.moduleList.GAME
        },
        canLoad: [openAccessGuard],
        loadChildren: () => import('../game/game.module')
          .then(m => m.GameModule)
      },
      {
        path: 'community',
        loadChildren: () => import('../web-community/web-community.module')
          .then(m => m.WebCommunityModule),
      },
      {
        path: 'open-article',
        loadChildren: () => import('../public-module/public-module.module')
          .then(m => m.PublicModule),
      },
      {
        path: 'samvaad',
        data: {
          moduleName: mls.featureOnOffList.moduleList.CHAT
        },
        canLoad: [openAccessGuard],
        loadChildren: () => import('../samvaad/samvaad.module')
        .then(m => m.SamvaadModule),
      },
      // {
      //   path: 'error', component: ErrorComponent
      // },
      { path: '', redirectTo: 'web', pathMatch: 'full' },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(appRoutes)
  ],
  exports: [RouterModule]
})
export class MiddleWareRoutingModule {

 }
